import { matchPath } from 'react-router';

import type { ApiEmbedSearchWidgetId } from 'api/types/ApiTypedId';
import { embedSearchWidgetRouteGroup } from 'modules/embedSearchWidget/routing/embedSearchWidget.routes';

export function getEmbedSearchWidgetIdFromPathname(
  pathname: string,
): ApiEmbedSearchWidgetId | undefined {
  const match = matchPath(embedSearchWidgetRouteGroup.wrapperPath, pathname);
  if (!match) return;

  return match.params.embedSearchWidgetId;
}
